import Icon from '../components/Icon.vue'

Icon.register({"flask":{"width":1664,"height":1792,"paths":[{"d":"M1527 1448q56 89 21.5 152.5t-140.5 63.5h-1152q-106 0-140.5-63.5t21.5-152.5l503-793v-399h-64q-26 0-45-19t-19-45 19-45 45-19h512q26 0 45 19t19 45-19 45-45 19h-64v399zM748 723l-272 429h712l-272-429-20-31v-37-399h-128v399 37z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/flask.js
// module id = 943
// module chunks = 0